import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert } from "reactstrap";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import TerminalIssuesService from "../../services/TerminalIssues";
import LocalstorageService from "../../helpers/localstorage-service";
import { CompanyId } from "../../constants";
import "./DeleteCalculationModal.css";

const DeleteCalculationModal = ({ isOpen, toggle, date, onDeleteComplete }) => {
    const { t } = useTranslation();
    const companyId = LocalstorageService.getItem(CompanyId);
    const [deleting, setDeleting] = useState(false);

    const formatDate = (dateObj) => {
        if (!dateObj) return "";
        const d = new Date(dateObj);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const formatDateForApi = (dateObj) => {
        if (!dateObj) return "";
        const d = new Date(dateObj);
        return d.toISOString().split("T")[0];
    };

    const handleDelete = async () => {
        setDeleting(true);
        try {
            const response = await TerminalIssuesService.deleteCalculationData({
                companyId,
                dateToDelete: formatDateForApi(date),
            });

            if (response.data.success) {
                toast.success(response.data.message);
                toggle();
                if (onDeleteComplete) onDeleteComplete();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(t("DELETE_CALCULATION.ERROR"));
        } finally {
            setDeleting(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} className="delete-calculation-modal">
            <ModalHeader toggle={toggle} className="delete-modal-header">
                ⚠️ {t("DELETE_CALCULATION.TITLE")}
            </ModalHeader>
            <ModalBody className="delete-modal-body">
                <div className="delete-warning-icon">🗑️</div>
                <div className="delete-message">{t("DELETE_CALCULATION.CONFIRM_MESSAGE")}</div>
                <div className="delete-date">{formatDate(date)}</div>
                <Alert color="warning" className="delete-warning">
                    ⚠️ {t("DELETE_CALCULATION.WARNING")}
                </Alert>
            </ModalBody>
            <ModalFooter className="delete-modal-footer">
                <Button color="secondary" onClick={toggle}>
                    {t("DELETE_CALCULATION.CANCEL")}
                </Button>
                <Button color="danger" onClick={handleDelete} disabled={deleting}>
                    {deleting ? t("DELETE_CALCULATION.DELETING") : t("DELETE_CALCULATION.DELETE")}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default DeleteCalculationModal;